// События обучения.
//
// Своей системы событий на фронте нет, подключён только LogRocket — туда и
// пишем, чтобы запись сессии можно было найти по событию. Заодно шлём событие
// в window.dataLayer, если он когда-нибудь появится: так подключить любую
// аналитику можно будет без правок здесь.
//
// Если события понадобятся на бэке (например, считать, сколько менеджеров
// дошло до конца), добавляйте отправку в одном этом файле.

import LogRocket from 'logrocket';

export const ONBOARDING_EVENTS = {
  tourStarted: 'onboarding_tour_started',
  tourStepShown: 'onboarding_tour_step_shown',
  tourSkipped: 'onboarding_tour_skipped',
  tourFinished: 'onboarding_tour_finished',
  checklistItemDone: 'onboarding_checklist_item_done',
  checklistHidden: 'onboarding_checklist_hidden',
};

export const trackOnboarding = (event, payload = {}) => {
  try {
    if (LogRocket && typeof LogRocket.track === 'function') {
      LogRocket.track(event, payload);
    }
  } catch (e) {
    // Аналитика не должна мешать работе: молча пропускаем.
  }

  try {
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...payload });
    }
  } catch (e) {
    // То же самое.
  }
};
